import { render, staticRenderFns } from "./VideoBienvenida.vue?vue&type=template&id=7c89ff82&scoped=true&"
import script from "./VideoBienvenida.vue?vue&type=script&lang=js&"
export * from "./VideoBienvenida.vue?vue&type=script&lang=js&"
import style0 from "./VideoBienvenida.vue?vue&type=style&index=0&id=7c89ff82&scoped=true&lang=css&"
import style1 from "./VideoBienvenida.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89ff82",
  null
  
)

export default component.exports